import { ServiceCard } from "./styles";
import React from "react";
export const ServicesCard = ({ url, icon, name }) => {
	return (
		<ServiceCard href={url} target="_blank" rel="noreferrer">
			<div className="card-top">
				<img src={icon} alt={name} />
			</div>
			<div className="card-bottom"> {name} </div>
		</ServiceCard>
	);
};
